import { render, staticRenderFns } from "./delegacion-form.vue?vue&type=template&id=0fa84388&scoped=true"
import script from "./delegacion-form.vue?vue&type=script&lang=js"
export * from "./delegacion-form.vue?vue&type=script&lang=js"
import style0 from "./delegacion-form.vue?vue&type=style&index=0&id=0fa84388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa84388",
  null
  
)

export default component.exports